<template>
	<div
		ref="infiniteScrollContainer"
		class="infinite-scroll-container js-scroll-wrapper"
	>
		<slot />
		<div
			id="scroll-trigger"
			ref="infiniteScrollTrigger"
			v-visible="!isLastPage"
		/>
	</div>
</template>

<script>

export default {
	name:  'InfiniteScroll',
	props: {
		isLastPage: Boolean,
	},
	mounted() {
		this.scrollTrigger();
	},
	methods: {
		loadMore() {
			this.$emit('load-more');
		},
		scrollTrigger() {
			const observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.isIntersecting > 0) {
						this.loadMore();
					}
				});
			});
			observer.observe(this.$refs.infiniteScrollTrigger);
		},
	},
};
</script>

<style lang="scss" scoped>
	.infinite-scroll-container {
		overflow-y: auto;
		overflow-x: hidden;

		.is-mobile & {
			overflow-y: initial;
		}
	}

	#scroll-trigger {
		height: 1px;
	}

</style>
